module.exports = "/images/menu-add-user.svg?d1ee849a770fa6b07aaa6d9cb200664c";